/**
 * Small helpers shared by the Commercial screens (accounts list, one account,
 * and the public service report).
 */
import { SERVER_ORIGIN } from '../services/api';
import { businessToday } from './time';

/** Days from Austin's today to a YYYY-MM-DD date (negative = already past). */
export function daysUntil(day?: string | null): number | null {
  if (!day) return null;
  const a = new Date(businessToday() + 'T12:00:00Z').getTime();
  const b = new Date(String(day).slice(0, 10) + 'T12:00:00Z').getTime();
  if (Number.isNaN(b)) return null;
  return Math.round((b - a) / 86400000);
}

/** "Due on receipt" / "Net 30". */
export function termsLabel(t?: number | null): string {
  if (t == null) return 'Net 30';
  return Number(t) === 0 ? 'Due on receipt' : `Net ${t}`;
}

export const TERMS_OPTIONS = [0, 15, 30, 45, 60];

/** Signed upload paths come back relative (/uploads/...); report links come back absolute. */
export function absUrl(u?: string | null): string {
  if (!u) return '';
  return /^https?:\/\//i.test(u) ? u : `${SERVER_ORIGIN}${u.startsWith('/') ? '' : '/'}${u}`;
}

/** Sep 23, 2026 — a bare day read as that day, not UTC midnight. */
export function dayLabel(d?: string | null): string {
  if (!d) return '—';
  const dt = new Date(String(d).slice(0, 10) + 'T12:00:00');
  if (Number.isNaN(dt.getTime())) return '—';
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export const DOC_KINDS: { value: 'coi' | 'w9' | 'contract' | 'other'; label: string }[] = [
  { value: 'coi', label: 'COI' },
  { value: 'w9', label: 'W-9' },
  { value: 'contract', label: 'Contract' },
  { value: 'other', label: 'Other' },
];
export const docKindLabel = (k?: string) => DOC_KINDS.find(d => d.value === k)?.label || 'Other';

/** Expiry tone: red once past, amber inside 30 days. */
export function expiryTone(day?: string | null): 'expired' | 'soon' | 'ok' | 'none' {
  const n = daysUntil(day);
  if (n == null) return 'none';
  if (n < 0) return 'expired';
  if (n <= 30) return 'soon';
  return 'ok';
}
